import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: startDate => ({
        date: Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'iaasVCenterResources',
        endpoint:           endpoints.iaas.iaasVCenterResources,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            results: !response.results ? [] : response.results.map(item => ({
                vmName:    item.vm_name,
                vmOn:      item.total_vm_on,
                vmOff:     item.total_vm_off,
                statusVm:  item.id_power_state,
                cpuVm:     item.cpu,
                ramVm:     item.ram,
                totalRam:  item.total_ram,
                storageVm: item.storage_mb / (1024 * 1000),
                vCenter:   item.vcenter_name,
                guestOs:   item.operating_system,
                cluster:   item.cluster,
                esxName:   item.esx_name,
                dedicate:  item.dedicate,
                ramEsx:    item.ram_esx,
                cpuEsx:    item.cpu_esx,
                coresCpu:  item.cores_per_cpu
            }))
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/iaasVCenterResources.js